import { getSignal } from '@api/helpers/transformer';

import { Data } from './types';

export const get =
    <T>(field: string) =>
    (entity: Data) =>
        getSignal<T | null>(entity, field, null);
